<template>
  <div class="warp_contrainer">
    <div class="search_container" style="text-align:right;">
      <el-button type="primary" @click="add()"><i class="el-icon-plus"></i> 添加 </el-button>
    </div>
    <div class="table_container">
      <el-table :data="addressList" border style="width: 100%" stripe>
        <el-table-column
          prop="goodType"
          label="货运类型"
          align="center"
          width="200px"
        >
         <template slot-scope="scope">
            {{ goodType(scope.row.goodType) }}
          </template>
        </el-table-column>
        <el-table-column label="国内仓地址" align="left">
          <template slot-scope="scope">
            {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="负责人" align="center" width="200px">
          <template slot-scope="scope">
            {{ scope.row.contacts }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" align="center" width="200px">
          <template slot-scope="scope">
            {{ scope.row.tel }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page="paginations.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :visible.sync="editDialog.show"
      :title="editDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="520px"
      center :show-close="false"
    >
      <el-form
        :model="editDialog.data"
        :rules="editDialog.form_rules"
        ref="editForm"
        label-position="right"
        label-width="120px"
      >
        <el-form-item prop="goodType" label="货物类型：">
           <el-select v-model="editDialog.data.goodType" clearable placeholder="货物类型">
              <el-option v-for="item in editDialog.goodTypeList"
                :key="item.goodType"
                :label="item.goodName"
                :value="item.goodType">
              </el-option>
           </el-select>
        </el-form-item>
        <el-form-item prop="contacts" label="负责人姓名：">
          <el-input
            v-model.trim="editDialog.data.contacts" type="text"
            placeholder="请输入负责人姓名"
            style="width: 300px"
            minlength="64"
          ></el-input>
        </el-form-item>
        <el-form-item prop="tel" label="负责人电话：">
          <el-input
            v-model.trim="editDialog.data.tel"
            type="text"
            placeholder="请输入负责人电话"
            style="width: 300px"
            minlength="128"
          ></el-input>
        </el-form-item>
        <el-form-item prop="address" label="国内仓地址：">
          <el-input
            v-model.trim="editDialog.data.address"
            type="textarea" :rows="2"
            placeholder="请输入国内仓地址："
            style="width: 300px"
            minlength="300"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog.show = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as StringUtils from "@/utils/StringUtils"
import * as addressApi from "@/api/address";
import { axios } from "utils/";
export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (!value) {
        let text;
        if (rule.field == "contacts") text = "请输入负责人姓名";
        else if (rule.field == "tel") text = "请输入负责人电话";
        else if (rule.field == "goodType") text = "请选择货物类型";
        else if (rule.field == "address") text = "请输入国内仓地址";
        return callback(new Error(text));
      } 
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改",
        data: {
          storeId: null,
          address: "",
          contacts: "",
          tel: "",
          goodType:null
        },
        goodTypeList:[
            {
              goodType:1,
              goodName:"海运"
            }, {
              goodType:2,
              goodName:"海运大件"
            }, {
              goodType:3,
              goodName:"空运"
            }
        ],
        form_rules: {
          goodType: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          tel: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          contacts: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          address: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ]
        },
      },
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 20, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      addressList: [], //列表
    };
  },
  created() {
    let that = this;
    that.getStoreList();
  },

  methods: {
    goodType(type){
       return StringUtils.goodType(type);
    },
    initData() {
      this.paginations.page_index = 1;
      this.getStoreList();
    },
    add(){
      this.editDialog.show = true;
      this.editDialog.data = {
          storeId: null,
          address: "",
          contacts: "",
          tel: "",
          goodType:null
      };
    },
    edit(row) {
      this.editDialog.show = true;
      this.editDialog.data = {
          storeId: row.storeId,
          address: row.address,
          contacts: row.contacts,
          tel: row.tel,
          goodType:row.goodType
      };
    },
    submit() {
      let that = this;

      let data = {
        storeId: that.editDialog.data.storeId,
        contacts: that.editDialog.data.contacts,
        tel: that.editDialog.data.tel,
        goodType: that.editDialog.data.goodType,
        address:  that.editDialog.data.address
      };
      that.$refs.editForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)",
          });
          if (data.storeId){
            addressApi.storeUpdate(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({message: "提交成功",type: "success"});
              that.getStoreList();
              that.editDialog.show = false;
            });
          }else{
            addressApi.storeAdd(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({message: "提交成功",type: "success"});
              that.getStoreList();
              that.editDialog.show = false;
            });
          }
        }
        
      });
    },
    getStoreList() {
      let that = this;
      let data = {};
      addressApi.getStoreList(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.addressList = res.data.data.list;

          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getStoreList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getStoreList();
    },
  },
};
</script>
<style scoped lang="less">
.wrap_container {
  .table_header {
    background-color: #ff0;
  }
}
</style>


// WEBPACK FOOTER //
// list.vue?1868ba56